/* eslint "react/prop-types": "warn" */
import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';

import GettingStartedGuide from "platopulse/reference/guide/GettingStartedGuide.jsx"
import GettingStartedGuideEditForm from "platopulse/reference/guide/GettingStartedGuideEditForm.jsx"

import * as metadataActions from 'platopulse/redux/metadata';
import * as actions from 'platopulse/reference/reference';

import {
    getDatabaseId,
    getIsEditing
} from '../selectors';


import {
    fetchDashboards
} from 'platopulse/dashboards/dashboards';

const mapStateToProps = (state, props) => ({
    databaseId: getDatabaseId(state, props),
    isEditing: getIsEditing(state, props)
});

const mapDispatchToProps = {
    fetchDashboards,
    ...metadataActions,
    ...actions
};

@connect(mapStateToProps, mapDispatchToProps)
export default class GettingStartedGuideContainer extends Component {
    static propTypes = {
        params: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        databaseId: PropTypes.number.isRequired,
        isEditing: PropTypes.bool
    };

    async fetchContainerData() {
        await actions.wrappedFetchGuide(this.props);
    }

    componentWillMount() {
        this.fetchContainerData()
    }

    componentWillReceiveProps(newProps) {
        if (this.props.location.pathname === newProps.location.pathname) {
            return;
        }

        actions.clearState(newProps)
    }

    render() {
        return (
            <div>
                
            { this.props.isEditing ? 
                <GettingStartedGuideEditForm {...this.props} /> :
                <GettingStartedGuide {...this.props} />
            }            
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./reference/guide/GettingStartedGuideContainer.jsx